import { io } from "socket.io-client";

// In production, prefer explicit socket URL or same origin; in development default to localhost:5000.
const SOCKET_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_SOCKET_URL || window.location.origin
    : process.env.REACT_APP_SOCKET_URL || "http://localhost:6000";

const socket = io(SOCKET_URL, {
  autoConnect: true,
  withCredentials: true,
});

export default socket;
